'use client';

import { usePathname, useRouter } from 'next/navigation';

import { styled } from '@lichtblick/styled';

import { SegmentedButton } from '../SegmentedButton';

export type PanelTab = {
  isDefault?: boolean;
  label: string;
  path: string;
};

type PanelTabHeaderProps = {
  tabs: PanelTab[];
};

const TabsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-s);

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    min-width: 0;

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--colors-blue-20);
      border-radius: 2px;

      &:hover {
        background: var(--colors-blue-50);
      }
    }
  }
`;

export const PanelTabHeader = ({ tabs }: PanelTabHeaderProps) => {
  const router = useRouter();
  const pathname = usePathname();

  const selectedTab =
    tabs.find((tab) => tab.isDefault)?.path ??
    [...tabs].reverse().find((tab) => pathname.includes(tab.path))?.path ??
    tabs[0]?.path;

  return (
    <TabsContainer>
      <SegmentedButton
        onOptionChange={(value) => router.push(value)}
        options={tabs.map((tab) => ({ label: tab.label, value: tab.path }))}
        value={selectedTab}
        variant="tabs"
      />
    </TabsContainer>
  );
};
